<template>
  <div id="app">
    <Wallpaper></Wallpaper>
    <MyName></MyName>
    <Nav></Nav>
    <router-view/>
    <div id="opener_showCase"></div>
  </div>
</template>
<script type="text/javascript">
  import Nav from '@/components/Nav.vue'
  import Wallpaper from '@/components/Wallpaper.vue'
  import MyName from '@/components/MyName.vue'
  import { containerSkewOpen, containerSkewClose, containerSkewFadeout } from './ui/UIUtil'

  const resizeThreshold      = 350;
  const minifyThresholdWidth = 600;

  export default {
    name: 'App',

    components: {
      Nav,
      Wallpaper,
      MyName
    },

    mounted() {
      console.info('global function for door');
      window.openDoor = () => containerSkewOpen( jQuery( '#opener_showCase') );
      window.closeDoor = () => containerSkewClose( jQuery( '#opener_showCase') );
      window.fadeInitialize = () => containerSkewFadeout(  jQuery( '#opener_showCase'), 0 );
      window.fadeInitialize();
    },

    created() {
      window.addEventListener("resize", this.resizeHandler );
      window.resizeHandlerExec = this.resizeHandlerExec.bind(this);
    },
    destroyed() {
      this.clearResizeTimer();
      window.removeEventListener("resize", this.resizeHandler);
    },
    methods: {
      clearResizeTimer() {
        if( this.resizeTimer != null ) {
          clearTimeout( this.resizeTimer );
          this.resizeTimer = null; 
        }
      },
      resizeHandler( e ) {
        this.clearResizeTimer();
        this.resizeTimer = setTimeout( this.resizeHandlerExec, resizeThreshold );
      },
      resizeHandlerExec(){
        let _navMinify = false;
        let defaultMenuOn = this.$store.state.menuOn || false 
        if( window.innerWidth < minifyThresholdWidth ){
          _navMinify = true;
          defaultMenuOn = false;
        }
        
        this.$store.commit( 'setWindowSize', {
          width: window.innerWidth,
          height: window.innerHeight
        });

        this.$store.commit( 'updateMenu', {
          navMinify: _navMinify,
          menuOn: defaultMenuOn
        });

      }

    }
  }

</script>

<style lang="scss">
@import "~@/ui/uiutil.scss";
@font-face {
  font-family: 'Sawarabi Mincho';
  src: url('~@/assets/fonts/Sawarabi_Mincho/SawarabiMincho-Regular.ttf');
  font-weight: 700;

}

@font-face {
  font-family: 'GT-Super-Text-Book';
  src: url('~@/assets/fonts/GT-Super-Text-Book.woff2');
}


@font-face {
  font-family: 'GT-Super-Text-Book-Italic';
  src: url('~@/assets/fonts/GT-Super-Text-Book-Italic.woff2');
}

@font-face {
  font-family: 'sabon-italic';
  src: url('~@/assets/fonts/sabon-italic.woff2');
}


html, body {
  font-family: 'GT-Super-Text-Book', sans-serif;
}


:root {
  --background: #ffffff29;
  --blob: #fdfbfd42;
  --shades: inset 10px 0 40px #f7f8fc85, inset -10px 0 20px #f7e1ef61, inset -40px 10px 100px #eadac326;
  --basecolor: #4B4B4B;
  
  @media (prefers-color-scheme: dark) {
    --background: #0f0c24;
    --blob: #bca5e3;
    --shades: inset 10px 0 40px #a174db,
              inset -10px 0 20px #40245e,
              inset -40px 10px 110px #1b1648;
  }
}

html,body{
  position:absolute;
  top:0px;
  left:0px;
  width:100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

body * {
  color: var(--basecolor);
}


span.cross{
  font-family: Arial;
}



#app {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

#opener_showCase{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 10px;
  height: 0px;
  background-color: #ff79a850;
  z-index: 1;
}

</style>
